<template lang="pug">
div.w-full
  pre.p-3.text-xs.font-mono.whitespace-pre.border.rounded {{ jsonString }}
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: any
}>()

const jsonString = computed(() => JSON.stringify(props.data, null, 2))
</script>
